// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { harvestSessionId } from './HarvestSession';
import { cleaningRecordId } from './CleaningRecord';
import { harvestCleaningPositionEnum } from './HarvestCleaningPositionEnum';
import { operatorId } from './Operator';
import { equipmentId } from './Equipment';
import { z } from 'zod';
export const harvestSessionCleaningId = (z.number());
export const harvestSessionCleaning = z.object({
    id: harvestSessionCleaningId,
    harvest_session_id: harvestSessionId,
    cleaning_record_id: cleaningRecordId,
    position: harvestCleaningPositionEnum,
    created_at: z.date(),
    created_by: operatorId.nullable(),
    equipment_id: equipmentId,
});
export const harvestSessionCleaningInitializer = z.object({
    id: harvestSessionCleaningId.optional(),
    harvest_session_id: harvestSessionId,
    cleaning_record_id: cleaningRecordId,
    position: harvestCleaningPositionEnum,
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    equipment_id: equipmentId,
});
export const harvestSessionCleaningMutator = z.object({
    id: harvestSessionCleaningId.optional(),
    harvest_session_id: harvestSessionId.optional(),
    cleaning_record_id: cleaningRecordId.optional(),
    position: harvestCleaningPositionEnum.optional(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    equipment_id: equipmentId.optional(),
});
//# sourceMappingURL=HarvestSessionCleaning.js.map